export const content = `## On mobile

1. When you login to your account, use the ![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXdgoymwTkYsmurHJwftDW8M2h4hzVGm5wlW3lapEu9YAloECp3nwNvB51DMKwdeMA0zur3hMiBw-CLaXV3C0MX0XK0rf5wtu0X_vF3zul2IDWIJUk6QNV535m8ge2Pol0-jpYQE6w?key=CRFWHqpHXz1EuwOLvDfBHFv7) icon to open your navigation menu.
2. Select [**Payments**](/payments).
3. Select the [**Payment Method**](/payments/method) tab.
4. At the bottom of the screen, select **Edit Payment Method**.
5. Add your payment information then select **Save**.

## On desktop

1. When you login to your account, go to [**Payments**](/payments) from your sidebar navigation.
2. Select the [**Payment Method**](/payments/method) tab.
3. Where your payment card and billing address appear, select **Edit Payment Method**.
4. Add your payment information then select **Save**.

## Why do I need to give my credit card information?

Your payment information is required to book a session but you won’t be charged until after the session has occurred. Before the session, your payment information is only used to ensure that session payments and no-show fees can be collected.
`;
